import type { IAudioState } from 'store/types/audio'

export const getInitialState = (): IAudioState => ({
  soundsGenres: [],
  userSounds: [],
  usedLibSounds: []
})
